export enum PDF_LINKS {
  TERMS = 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/seguros/affinity/termos/termo_cartao_protegido.pdf',
  MANUAL = 'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/seguros/affinity/manuais/manual_cartao_protegido.pdf',
}
